module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p13"
    }
  }), _vm._v(" Biker Patriot Uncle John's Nasty Black Coffee")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Here is a cup of Joe that will make your hair stand on end, if you are crazy enough to drink it. This recipe comes from Josh Placa's Uncle John. J. Joshua Placa is the editor of "), _c('em', [_vm._v("Cruising Rider")]), _vm._v(" magazine. Biking and brewing go back generations in his family, as do cast-iron stomachs. Josh is a Harley-riding buddy of mine who calls the Arizona desert home, so you know he is a fiery biker. Josh sent along this quote from his uncle: \"Sometimes, when times were hard, you just had to use what was around. And if you were wrenching on a Panhead and got hungry, sometimes parts fell in the pot. Not bad for ya, added a little iron. Just had to remember to let all the heavy stuff settle to the bottom.\"")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Since this recipe is as vintage as a '49 Panhead, I have left it \"unrestored\" so you can savor the original flavor and style; I think in antique bike terminology this recipe is what would be called \"barn fresh.\" As Uncle John would say, \"No milk allowed. Sugar is for sissies. Ya can add ¼ teaspoon cayenne pepper or one cinnamon stick [for weak stomachs] while brewing.\"")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Raw coffee beans")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Big, old-fashioned stained and chipped enamel coffee pot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Some water")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Reach into the coffee sack and grab yourself a big handful of beans. Fill the pot about two thirds full with cold tap water. Crush the beans with your hand and throw them hard into the pot. Bring to a boil, then simmer over low heat for about 10 minutes. Enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES")]), _vm._v(" 1 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("SERVING")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262beb32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c008.vue
// module id = 105
// module chunks = 0